<template>
  <div id="side-bar">
    <el-menu
      :default-active="$route.path"
      :unique-opened="true"
      class="menu"
      :background-color="this.$root.colorController"
      :text-color="(this.$root.colorController == '#000' ? '#bdbdbd' : '#000')"
      :collapse="false">

      <menu-item :menu="menu" :col="this.$root.colorController"></menu-item>
    </el-menu>
  </div>
</template>

<script>
import MenuItem from './MenuItem'

export default {
  name: 'LeftMenu',
  components: {
    MenuItem
  },
  computed: {
    menu() {
      return this.$store.state.user.menu
    }
  }
}
</script>

<style scoped>
  #side-bar {
    width: 201px !important;
  }

  /* 菜单栏高度充满屏幕 */
  #side-bar,
  .menu {
    height: 100%;
  }

</style>
